<template>
  <el-tabs type="border-card" :stretch="true">
    <el-tab-pane label="Base Info">
        <el-form label-width="150px" class="detail">
            <el-form-item label="Offer Month">
                <div>{{result.offer_month}}</div>
            </el-form-item>
            <el-form-item label="Offer Id">
                <div>{{result.offer_id}}</div>
            </el-form-item>
            <el-form-item label="Offer Name">
                <div>{{result.offer_name}}</div>
            </el-form-item>
            <el-form-item label="Adv Offer Id">
                <div>{{result.adv_offer_id}}</div>
            </el-form-item>
            <el-form-item label="Af Prt">
                <div>{{result.af_prt}}</div>
            </el-form-item>
            <el-form-item label="Adv Id">
                <div>{{result.adv_id}}</div>
            </el-form-item>
            <el-form-item label="Adv Name">
                <div>{{result.adv_name}}</div>
            </el-form-item>
            <el-form-item label="Manager">
                <div>{{result.offer_bd}}</div>
            </el-form-item>
            <el-form-item label="Manual Status">
                <div :class="'status-'+result.manual_status">{{result.manual_status&&result.manual_status.toUpperCase()}}</div>
            </el-form-item>
            <el-form-item label="Offer Price">
                <div>{{result.offer_price}}</div>
            </el-form-item>
            <el-form-item label="Payable Event">
              <el-table :data="result.events">
                <el-table-column prop="event_name" label="Event Name"></el-table-column>
                <el-table-column prop="event_value" label="Event Value"></el-table-column>
                <el-table-column prop="payout" label="Payout"></el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item label="Cap">
                <div>{{result.cap_info}}</div>
            </el-form-item>
            <el-form-item label="Pricing Model">
                <div>{{result.pricing_model}}</div>
            </el-form-item>
            <el-form-item label="Traffic Type">
                <div>{{result.traffic_type}}</div>
            </el-form-item>
            <el-form-item label="Platform">
                <div>{{result.platform}}</div>
            </el-form-item>
            <el-form-item label="Remark">
                <div>{{result.remark}}</div>
            </el-form-item>
            <el-form-item label="Copy Action">
                <div>
                    <el-button slot="save" size="medium" type="primary" @click="copyPid()">Copy Pid</el-button>
                </div>
            </el-form-item>
        </el-form>
    </el-tab-pane>

    <el-tab-pane label="App Info">
      <el-form label-width="150px" class="detail">
        <el-form-item label="Category">
          <div>{{result.category}}</div>
        </el-form-item>
        <el-form-item label="Geo">
          <div>{{result.geo}}</div>
        </el-form-item>
        <el-form-item label="Offer Kpi">
          <div v-html="result.kpi"></div>
        </el-form-item>
        <el-form-item label="App Name">
          <div>{{result.app_name}}</div>
        </el-form-item>
        <el-form-item label="Package Id">
          <div>{{result.package_id}}</div>
        </el-form-item>
        <el-form-item label="Preview Url">
          <a :href="result.preview_url" target="_blank" >{{result.preview_url}}</a>
        </el-form-item>
        <el-form-item label="Icon Url">
          <div>{{result.icon_addr}}</div>
        </el-form-item>
        <el-form-item label="App Description">
          <div v-html="result.description"></div>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- <el-tab-pane label="Campaign Links">
      <el-form label-width="150px" class="detail">
        <el-form-item v-for="(item, key) in result.camps" :label="`${item.channel_id}-${item.channel_name}`" :key="key">
          <a :href="item.tracking_link" target="_blank">{{item.tracking_link}}</a>
          <div>{{ item.tracking_link }}</div>
        </el-form-item>
      </el-form>
    </el-tab-pane> -->
    <el-tab-pane label="Channel Info">
      <el-form label-width="150px" class="detail">
        <el-form-item label="Show Kpi">
          <el-switch v-model="show_kpi"/>
        </el-form-item>
        <el-form-item v-for="(item, key) in result.camps" :label="`${item.channel_id}-${item.channel_name}`" :key="key">
          <div class="channel-info">
            <span>
              <div>pid: {{item.pid}}</div>
              <div>caps: {{item.cap_info}}</div>
              <div>payout: {{item.offer_price}}$</div>
              <div>manual status: <span :class="'status-'+item.manual_status">{{ item.manual_status.toUpperCase() }}</span></div>
              <div>link: 
                <el-popover
                  placement="bottom"
                  width="700"
                  trigger="click"
                >
                  <div v-html="item.tracking_link.replace(/\n/g, '<br/>')"></div>
                  <el-button slot="reference" type="text">{{ item.tracking_link.substring(0, 30) + '...' }}</el-button>
                </el-popover>
                <!-- <el-button @click="showTrackLink(item.tracking_link)" type="text">{{ item.tracking_link.substring(0, 30) + '...' }}</el-button> -->
              </div>
            </span>
            <span>
                <el-dropdown size="mini" trigger="click" slot="statusAction">
                  <el-button size="mini" type="primary">
                    <i class="el-icon-edit"></i>Channel {{item.channel_id}}
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="copyInfo(item.channel_id, item.pid)">Copy</el-dropdown-item>
                    <el-dropdown-item @click.native="sendMail(item.channel_id, item.pid)">Send Email</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
            </span>
          </div>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    
    <el-dialog
      title="Send Email"
      :visible.sync="sendMailVisible"
      width="80%"
      append-to-body
    >
      <div class="send-mail-dialog-container">
        <el-form
          :model="mailInfo"
          label-width="200px"
        >
          <el-form-item label="Title">
            <el-input v-model="mailInfo.title"></el-input>
          </el-form-item>
          <el-form-item label="Content" style="height:360px;">
            <quillEditor :value="mailInfo.msg" v-model="mailInfo.msg"></quillEditor>
          </el-form-item>
        </el-form>
        <div style="text-align: right">
          <el-button type="primary" @click="sendMailSubmit" :disabled="sendMailLoading">Submit</el-button>
        </div>
      </div>
    </el-dialog>
  </el-tabs>

</template>
<script>
import quillEditor from '../components/common/quillEditor.vue';
export default {
components: {
  quillEditor,
},
data() {
   const monthName = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec',
  };
  const nowMonthName = monthName[this.$utils.date_format(new Date(), 'MM')];
  return {
    result: {
      events: [],
    },
    show_kpi: true,
    nowMonthName,
    mailInfo: {
      title: '',
      msg: '',
    },
    sendMailLoading: false,
    sendMailVisible: false,
  };
},
methods: {
  showTrackLink(link) {
    this.$notify({
      title: 'Tracking Link',
      dangerouslyUseHTMLString: true,
      customClass: 'custom-tracking-link-notify',
      message: `<div style="width:600px;max-height:700px;overflow-wrap: break-word;font-size:17px;">${link && link.replace(/\n/g, '<br/>')}</div>`,
      position: 'top-right',
      duration: 0,
    });
  },
  async loaddata(offer_id, offer_month) {
    this.result = await this.$post("/mmpOffer/detail", { offer_id, offer_month });
    if (this.result.description) {
        this.result.description = this.result.description.replace(/\n/g, '<br/>');
    }
    if (this.result.kpi) {
        this.result.kpi = this.result.kpi.replace(/\n/g, '<br/>');
    }
    if (!this.result.events) {
      this.result.events = [];
    }
  },
  async copyPid() {
    if (this.result.camps && this.result.camps.length) {
      const pidArr = this.result.camps.map((camp) => {
        return camp.pid;
      });
      const text = pidArr.join('\n');
      await this.$copyText((text));
      this.$message({
        type:'success',
        message:'Copied Pid success',
      })
    } else {
      this.$message({
        type:'warning',
        message:'Have not camp',
      })
    }
  },
  async copyInfo(channel_id, pid, isReturn = false) {
    const default_kpi = 'No fraud, No bot, D1RR>35%';
    const reg1 = /(<(\/\w+|\w+|\w+\s{0,}\/)>)/g;
    const reg2 = /(&\w{2,};)/g;
    const camp = this.result.camps.find((row) => { return row.channel_id == channel_id && row.pid == pid });
    let kpi = this.result.kpi.replace(default_kpi, '').replace(/<br\/>/ig, `\r`);
    if (!this.show_kpi) {
      kpi = '';
    }
    let text = `${this.result.offer_id}_${this.nowMonthName}_MMP-${this.result.offer_name}_${camp.pid}_${camp.channel_name}\r` +
      `${this.result.offer_name}\r` +
      `${this.result.preview_url}\r\r` +
      `${camp.pid}\r`+
      `Tracking Link: ${camp.tracking_link}\r\r`+
      `GEO: ${this.result.geo}\r`+
      `Payable event: ${camp.events.map((row) => { return row.event_name }).join(',') || this.result.events.map((row) => { return row.event_name }).join(',')}\r`+
      `Payout: ${camp.offer_price}$\r`+
      `Cap: ${camp.cap_info || this.result.cap_info || ''}\r`+
      (this.show_kpi?`KPI: \r${kpi}\r`:'')+
      `\r\rNoted: It's the budget of this offer for this month ONLY! Pls pause the offer on the last day of the month !!!`
    if (isReturn) {
      return {
        msg: text,
        title: `${this.result.offer_name}/${camp.channel_name}(${pid})/${this.result.offer_id}`,
      }
    } else {
      await this.$copyText((text));
      this.$message({
        type:'success',
        message:'Copied ' + channel_id + ' success',
      })
    }
  },
  async sendMail(channel_id, pid) {
    this.mailInfo = await this.copyInfo(channel_id, pid, true);
    
    const default_kpi = 'No fraud, No bot, D1RR>35%';
    const camp = this.result.camps.find((row) => { return row.channel_id == channel_id && row.pid == pid });
    let kpi = this.result.kpi && this.result.kpi.replace(default_kpi, '').replace(/<br\/>/ig, `\r`);
    if (!this.show_kpi) {
      kpi = '';
    }
    const arr = [
      { label: 'Offer Name', value: this.result.offer_name },
      { label: 'Package Id', value: this.result.package_id, type: 'row' },
      { label: 'Preview Link', value: this.result.preview_url },
      { label: 'Tracker', value: this.result.tracker_id, type: 'row' },
      { emptyRow: true },
      { label: 'GEO', value: this.result.geo, type: 'row' },
      { label: 'Payable event', value: camp.events.map((row) => { return row.event_name }).join(',') || this.result.events.map((row) => { return row.event_name }).join(','), type: 'row' },
      { label: 'Cap', value: camp.cap_info || this.result.cap_info || '', type: 'row' },
      { label: 'Payout', value: camp.offer_price, type: 'row' },
      { emptyRow: true },
      { label: 'KPI', value: kpi.replace(/\r/ig, '<br/>') },
      { emptyRow: true },
      { emptyRow: true },
      { label: 'Pid', value: pid },
      { label: 'Tracking Link', value: camp.tracking_link },
    ];
    let text = `<div>hi team,</div>
                <div><br/></div>
                <div>Please check below new mmp offer :</div>
    `;
    for (const row of arr) {
      if (row.emptyRow) {
        text += `<div><br/></div>`
      } else if (row.type == 'row') {
        text += `<div>${row.label}: ${row.value}</div>`
      } else {
        text += `<div>${row.label}:</div><div>${row.value}</div>`
      }
    }
    text += `<div><br/></div>
              <div><br/></div>
              <div>Notes:</div>
              <div>Please pause the camapign on the last day of the month if we don't update the budget by email for next month. Thanks.</div>`;
    this.mailInfo.msg = text;
    this.mailInfo.channel_id = channel_id;
    this.sendMailVisible = true;
  },
  async sendMailSubmit() {
    const msg = `<div>
      ${this.mailInfo.msg}
      </div>`;
    // console.log(msg);
    this.sendMailLoading = true;
    await this.$post('/mmpOffer/sentDetailMail', { 
      ...this.mailInfo,
      msg,
    }).then(() => {
      this.$message({
        type:'success',
        message:'Email sending...',
      })
      this.sendMailVisible = false;
    }).finally(() => {
      this.sendMailLoading = false;
    })
  },
},
props: ["id"],
watch: {
  id(v) {
    const offer_info = v.split(',');
    this.loaddata(offer_info[0], offer_info[1]);
  },
},
mounted() {
  const offer_info = this.id.split(',');
  this.loaddata(offer_info[0], offer_info[1]);
}
};
</script>

<style>
.custom-tracking-link-notify {
    width: 700px;
}
</style>
<style scoped>
div{
      overflow-wrap: break-word;
}
.detail-tab {
background-color: rgb(175, 187, 236);
height: 30px;
width: 100%;
text-align: center;
vertical-align: bottom;
}
.el-form-item {
/* margin:0 10px 0 10px; */
width: 100%;
border-style: solid;
border-color: rgb(230, 230, 230);
border-width: 0px 0px 1px 0px;
}
.channel-info {
  display: flex;
  justify-content: space-between;
}
.affilitest-button-result {
  display: flex;
  justify-content: space-around;
}
.send-mail-dialog-container .el-form-item {
  border: none;
}
</style>
